import React, { useState } from 'react';
import { Empty, Row, Col, Button, List, Popconfirm } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTools, faBoxCheck, faMinusCircle} from "@fortawesome/pro-duotone-svg-icons";
import { AddServico } from './AddServico'
import { useAxios } from '../../hooks';
import { useSelector, useDispatch } from 'react-redux';
import { Dinheiro } from '..';
import { usePedido } from '../../services/usePedidos';

const Servicos = () => {
    const [addServicoVisible, setAddServicoVisible] = useState(false);
    const {removerServicoDb} = usePedido();
 

    const reducerServicos = useSelector((state) => state.reducerServicos);
    

    const reducerPedido = useSelector((state) => state.reducerPedido);
    const pedido = reducerPedido.pedido;

    const dispatch = useDispatch();

    

    const close = () => {
        setAddServicoVisible(false);
    }

    const drawer = () => {
        return <AddServico visible={addServicoVisible} close={close} title={"Adicionar Serviço"} /* reducer={reducer} */></AddServico>
    }

    const onClickButtonServico = () => {
        setAddServicoVisible(true);
    }

    const button = () => {
        return <Button type="primary" onClick={onClickButtonServico}>Inserir Serviço</Button>
    }

    if(pedido.servicos && pedido.servicos.length){
        var key=1;
        return <>
            <List
                
                style={{textAlign: 'left'}}
                itemLayout="horizontal"
                dataSource={pedido.servicos}
                
                renderItem={ servico => {
                    
                    let removing = false;

                     const removerServico = async () => {
                        removing = true;
                        const novoPedido = await removerServicoDb(pedido, servico);
                        removing = false;
                        dispatch({type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: novoPedido});
                    } 


                    return (
                    <List.Item  key={++key} >
                        <List.Item.Meta
                            avatar={<FontAwesomeIcon size="2x" icon={faBoxCheck}></FontAwesomeIcon>}
                            title={servico.descricaoServico}
                             description={<>
                                Valor: {servico.quantidade }x <Dinheiro value={servico.valorServico} /> | 
                                Desc: <Dinheiro value={servico.totalDescontos}></Dinheiro></> }
                        ></List.Item.Meta>
                        { <div>
                            <Dinheiro value={servico.totalServico}></Dinheiro>
                        </div> }

                        { (() => {
                            
                                return (
                                    <div style={{display: "block"}}>
                                        <Popconfirm placement="topLeft" title="Tem Certeza?" onConfirm={removerServico} okText="Sim" cancelText="Não">
                                            <Button type="text" loading={removing} style={{color: "red"}}><FontAwesomeIcon icon={faMinusCircle} ></FontAwesomeIcon></Button>
                                            
                                        </Popconfirm>
                                    </div>
                                );
                            
                        })() }
                    </List.Item>
                )}}
                rowKey={(x)=>{return x.id+(key++)}}></List>
            {button()}
            {drawer()}
        </>
    } 

    return <>
        <Row>
            <Col span={24} style={{ textAlign: 'center' }}>
                <Empty
                    description="Nenhum serviço adicionado. Insira seu primeiro!"
                    image={
                        <FontAwesomeIcon
                            size="5x"
                            icon={faTools}>
                        </FontAwesomeIcon>
                    } >
                    {button()}
                    {drawer()}
                </Empty>
            </Col>
        </Row>

    </>;
}

export { Servicos };